import { render, staticRenderFns } from "./ChangePriceModal.vue?vue&type=template&id=770f3540&scoped=true"
import script from "./ChangePriceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePriceModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChangePriceModal.vue?vue&type=style&index=0&id=770f3540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f3540",
  null
  
)

export default component.exports